import 'babel-polyfill';
//import 'core-js/stable';
//import 'core-js/stable/symbol';
//import 'core-js/stable/object';
//import 'core-js/stable/array';
//import 'core-js/stable/promise';
//import 'core-js/stable/map';
//import 'core-js/stable/set';
//import 'regenerator-runtime/runtime';
import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import { store } from '@/store/index.js';
import VueLazyload from 'vue-lazyload';
import ApiClient from '@/plugins/api-plugin';
import FamppyPlugin from '@/plugins/famppy-plugin';
import VueReportPlugin from '@/plugins/report-vue-plugin';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueMoment from 'vue-moment';
import momentTimeZone from 'moment-timezone';
import VueSession from 'vue-session';
import VTooltip from 'v-tooltip';
//import VueAgile from 'vue-agile';
import VueDaumPostcode from 'vue-daum-postcode';
import VueTextareaAutosize from 'vue-textarea-autosize';
import lzString from 'lz-string';
import Datepicker from 'vuejs-datepicker';
//import Es6Promise from 'es6-promise';
//Es6Promise.polyfill();
var sessionOptions = {
	persist: true,
};
Vue.use(VueSession, sessionOptions);
library.add(fas);
library.add(far);
//Vue.use(VueAgile);
Vue.use(VueMoment, { momentTimeZone });
Vue.use(VTooltip);
Vue.use(Datepicker);
Vue.use(VueTextareaAutosize);
Vue.use(VueDaumPostcode);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.config.productionTip = false;
Vue.use(VueLazyload, {
	preLoad: 1,
	attempt: 1,
});
Vue.use(FamppyPlugin);
Vue.use(VueReportPlugin);
Vue.use(ApiClient);
// 로그인이 필요없는 페이지 선언
let authException = ['/login', '/mybusiness/auth/'];
router.beforeEach((to, from, next) => {
	if (authException.indexOf(to.fullPath) < 0) {
		let storage = window.localStorage;
		let dt = '';
		if (storage) {
			dt = lzString.decompressFromUTF16(storage.getItem('LOGIN_USER'));
		}
		let loginMember = null;
		if (dt) loginMember = JSON.parse(dt);
		if (loginMember) {
			next();
		} else {
			next({ path: '/login' });
		}
	} else {
		next();
	}
});
window.vm = new Vue({
	router,
	store,
	mounted() {
		var app = this;
		if ('-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style) {
			window.addEventListener(
				'hashchange',
				function() {
					var currentPath = window.location.hash.slice(1);
					if (app.$route.path !== currentPath) {
						app.$router.replace(currentPath);
					}
				},
				false,
			);
		}
	},
	render(h) {
		return h(App);
	},
}).$mount('#app');
